import {useMutation} from '@tanstack/react-query';
import {UpdateRefundProcedureParams} from 'domain/usecases/private/refund/request/update-procedure';
import {updateProcedure} from '../services/updateProcedure';

export const useUpdateProcedureMutation = () =>
	useMutation({
		mutationFn: (params: UpdateRefundProcedureParams) => updateProcedure(params),
		retry: 1,
	});
